import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { checkRange } from '../util';
import BaseView from './base';
var MatrixSubView = /*#__PURE__*/function (_BaseView) {
  _inherits(MatrixSubView, _BaseView);
  function MatrixSubView(matrix, startRow, endRow, startColumn, endColumn) {
    var _this;
    _classCallCheck(this, MatrixSubView);
    checkRange(matrix, startRow, endRow, startColumn, endColumn);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MatrixSubView).call(this, matrix, endRow - startRow + 1, endColumn - startColumn + 1));
    _this.startRow = startRow;
    _this.startColumn = startColumn;
    return _this;
  }
  _createClass(MatrixSubView, [{
    key: "set",
    value: function set(rowIndex, columnIndex, value) {
      this.matrix.set(this.startRow + rowIndex, this.startColumn + columnIndex, value);
      return this;
    }
  }, {
    key: "get",
    value: function get(rowIndex, columnIndex) {
      return this.matrix.get(this.startRow + rowIndex, this.startColumn + columnIndex);
    }
  }]);
  return MatrixSubView;
}(BaseView);
export { MatrixSubView as default };